import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoService } from 'src/app/services/sso.service';
import Swal from 'sweetalert2';
import { MemberService } from 'src/app/services/member.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { ConfigService } from '../../services/config.service';
@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css'],
})
export class SsoComponent implements OnInit {
  code: string | null = null;
  errMsg: string = '';

  isLoading: boolean = true;
  siteName: string = '';
  constructor(
    private route: ActivatedRoute,
    private sso: SsoService,
    private router: Router,
    private memberService: MemberService,
    private translate: TranslateService,
    private data: DataService,
    private configService: ConfigService,
  ) {
    this.siteName = this.configService.siteName;
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      switch (this.siteName) {
        case 'KKU':
          this.code = params.get('code');
          if (this.code) {
            this.getAccessToken(this.code);
          } else {
            this.isLoading = false;
          }
          break;

        case 'KMITL':
          const raw = params.get('ssoreturn');
          if (raw) {
            try {
              this.code = decodeURIComponent(raw);
            } catch (e) {
              this.code = raw;
            }
            const id = this.sso.decryptKMITL(this.code);
            this.getWALAIUser(id);
          } else {
            this.isLoading = false;
          }
          break;

        case 'YRU':
          this.code = params.get('code');
          if (this.code) {
            this.getYRUToken(this.code);
          } else {
            this.isLoading = false;
          }
          break;

        default:
          this.handleError('This username has locked!');
          this.isLoading = false;
          break;
      }
    });
  }

  clickLogin() {
    switch (this.siteName) {
      case 'KKU':
        window.location.href = this.sso.getKKULoginLogOutUrl(true);
        break;
      case 'KMITL':
        window.location.href = this.sso.getKMITLLoginLogOutUrl(true);
        break;
      case 'YRU':
        window.location.href = this.sso.getYRULoginLogOutUrl(true, this.sso.getYRUOAuthInfo().redirectUri);
        break;
      default:
        this.handleError('This username has locked!');
        break;
    }
  }


  getYRUToken(code: string): void {
    this.sso.getYRUToken(code).subscribe({
      next: (tokenData) => {
        if (tokenData && tokenData.access_token) {
          this.sso.getYRUUserInfo(tokenData.access_token).subscribe({
            next: (userData) => {
              const barcode = userData.data.type === 'staff'
                ? userData.data.staff.staffcode
                : userData.data.student.studentcode;

              if (barcode) {
                this.getWALAIUser(barcode);
              } else {
                this.handleError('ไม่พบข้อมูลผู้ใช้จาก YRU');
              }
            },
            error: (err) => {
              console.error('Error fetching YRU user info:', err);
              this.handleError('ไม่สามารถดึงข้อมูลผู้ใช้จาก YRU ได้');
            }
          });
        } else {
          this.handleError('ไม่สามารถรับ Access Token จาก YRU ได้');
        }
      },
      error: (error) => {
        console.error('Error fetching YRU token:', error);
        this.handleError('เกิดข้อผิดพลาดในการเชื่อมต่อกับ YRU');
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAccessToken(code: string): void {
    this.sso.getAccessToken(code).subscribe({
      next: (response) => {
        if (!response.ok) {
          console.error('Error fetching access token:', response.error);
          return;
        } else {
          if (!response.citizenId) {
            console.error('Citizen ID not found in response:', response);
            return;
          }
          this.getWALAIUser(response.citizenId);
          // You can store the access token in local storage or use it as needed
          // localStorage.setItem('accessToken', response.accessToken);
        }

        // Handle the response, e.g., store the access token
        // localStorage.setItem('accessToken', response.access_token);
      },
      error: (error) => {
        console.error('Error fetching access token:', error);
      }
    }).add(() => {
      this.isLoading = false; // Set loading to false after the request completes
    });
  }

  //GET api/getWALAIUser/{user}
  getWALAIUser(username: string) {
    this.isLoading = true;
    this.memberService.getWALAIUser(username).subscribe({
      next: (getData: any) => {
        if (!getData || getData.length === 0) {
          this.handleError('ไม่พบสมาชิก (' + username + ') ในระบบห้องสมุด');
          return;
        }

        const user = getData[0];
        if (user.LOCKED == 1) {
          this.handleError('This username has locked!');
          return;
        }

        if (user.USERSTATUS == 2) {
          this.handleError('This username has expired!');
          setTimeout(() => this.redirectToMain(getData), 1000);
          return;
        }

        if (user.USERSTATUS == 4) {
          this.handleError('This username is retired!');
          return;
        }

        this.redirectToMain(getData);
      },
      error: (error) => {
        console.error('Error fetching WALAI user:', error);
        this.handleError('ไม่สามารถเข้าสู่ระบบได้');
      }
    }).add(() => {
      this.isLoading = false;
    });
  }


  redirectURL = null;

  redirectToMain(getData: any) {
    this.isLoading = true; // Set loading to false after the request completes
    localStorage.setItem('WALAIcurrentUser', JSON.stringify(getData));
    this.data.updateMemberImg(getData[0].PATHPIC);
    this.data.updateMemberAccount(getData);

    if (this.redirectURL != null) {
      window.location.href = this.redirectURL;
    } else {
      this.router.navigateByUrl('/member');
    }
  }

  ErrorlogIn(msg: string) {
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  private handleError(messageKey: string) {
    this.errMsg = this.translate.instant(messageKey);
    this.ErrorlogIn(this.errMsg);
  }
}
